import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	unassigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	unassigned: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.assignee.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Placeholder for assignee field of an issue, when issue is unassigned',
	},
});
export default messages;
